import { useRef, useEffect } from "react";

import "./clicked-outside.css";

export function ClickedOutside(props) {
    const ref = useRef(null);

    useEffect(() => {
        function eventListener(event) {
            if (!ref.current) {
                return;
            }

            if (ref.current.contains(event.target)) {
                return;
            }

            if (props.clickedOutside) {
                props.clickedOutside();
            }
        }

        document.addEventListener("mousedown", eventListener);
        return () => {
            document.removeEventListener("mousedown", eventListener);
        };
    }, [ref, props]);

    const className = props.class || "";

    return (
        <div className={`clicked-outside ${className}`} ref={ref}>
            {props.children}
        </div>
    )
}